export const getProcessEnv = (n: string) => {
  return typeof process !== 'undefined' && process.env && process.env[n]
}

export const isTestEnv = () => {
  return getProcessEnv('NODE_ENV') === 'test'
}

export const isDevelopmentEnv = () => {
  return (
    getProcessEnv('NODE_ENV') === 'development' ||
    (window && window.location.hostname.indexOf('local.sumoci.net') >= 0)
  )
}

export const isReduxLoggingEnabled = () => {
  return !!getProcessEnv('REDUX_LOGGER')
}
